var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ show: _vm.open }, 'modal']},[_c('div',{staticClass:"modal-content"},[(_vm.closeIcon)?_c('span',{staticClass:"close",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_c('img',{attrs:{"width":"20","src":"/x-circle.svg","alt":""}})]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }